/*
 * @Author: Chen Zhen
 * @LastEditors: Chen Zhen
 * @Description: 位置组织 相关类
 * @Date: 2019-03-25 09:03:01
 * @LastEditTime: 2019-03-25 14:56:50
 */

// TODO 将对应的属性值进行移除到外边

/* eslint-disable  no-underscore-dangle */

const WIDTH_PERCENT = 0.94

const BUTTON_SIZE = 30

export default class Position {
  constructor(option, style) {
    this.option = option

    this.style = style

    this._displayStyle = option.displayStyle

    this._init()
  }

  /* 横向点位置初始化 */
  setHorizontalPosition() {
    this.allWidth = this.style.width * WIDTH_PERCENT
    this.marginLeft = (this.style.width - this.style.width * WIDTH_PERCENT) / 2

    this.linePosition1 = [ null, this.style.middleHeight ] // 横线起始点
    this.linePosition2 = [ null, this.style.middleHeight ] // 横线终止点

    this.leftPosition = [ null, this.style.middleHeight ] // 左按钮
    this.rightPosition = [ null, this.style.middleHeight ]// 右按钮

    this.playPosition = [ null, this.style.middleHeight ] // 播放按钮
  }

  /* 垂直点位置初始化 */
  setVerticalPosition() {
    this.allHeight = this.style.height * WIDTH_PERCENT
    this.marginTop = (this.style.height - this.style.height * WIDTH_PERCENT) / 2

    this.linePosition1 = [ this.style.middleWidth, null ] // 竖线起始点
    this.linePosition2 = [ this.style.middleWidth, null ] // 竖线终止点

    this.topPosition = [ this.style.middleWidth, null ] // 上按钮
    this.bottomPosition = [ this.style.middleWidth, null ] // 下按钮

    this.playPosition = [ this.style.middleWidth, null ]// 播放按钮
  }

  /**
   * 初始化
   */
  _init() {
    // 横向
    if (this._displayStyle === 'horizontal') {
      this.setHorizontalPosition()
      if (this.option.control.play.show) {
        // 有播放按钮
        if (this.option.control.play.position === 'left') {
          this.playPosition[0] = this.marginLeft + BUTTON_SIZE / 2
          this.leftPosition[0] = this.marginLeft + BUTTON_SIZE + BUTTON_SIZE / 2
          this.rightPosition[0] = this.marginLeft + this.allWidth - BUTTON_SIZE / 2

          this.linePosition1[0] = this.marginLeft + BUTTON_SIZE * 2
          this.linePosition2[0] = this.marginLeft + this.allWidth - BUTTON_SIZE
        } else if (this.option.control.play.position === 'right') {
          this.playPosition[0] = this.marginLeft + this.allWidth - BUTTON_SIZE / 2
          this.leftPosition[0] = this.marginLeft + BUTTON_SIZE / 2
          this.rightPosition[0] = this.marginLeft + this.allWidth - BUTTON_SIZE - BUTTON_SIZE / 2

          this.linePosition1[0] = this.marginLeft + BUTTON_SIZE
          this.linePosition2[0] = this.marginLeft + this.allWidth - BUTTON_SIZE * 2
        } else {
          throw new RangeError('\'opt.play.position\' must \'left\' of \'right\'')
        }
      } else {
        // 无播放按钮
        this.playPosition = null
        this.leftPosition[0] = this.marginLeft + BUTTON_SIZE / 2
        this.rightPosition[0] = this.marginLeft + this.allWidth - BUTTON_SIZE / 2

        this.linePosition1[0] = this.marginLeft + BUTTON_SIZE
        this.linePosition2[0] = this.marginLeft + this.allWidth - BUTTON_SIZE
      }
    } else if (this._displayStyle === 'vertical') {
      // 垂直
      this.setVerticalPosition()
      if (this.option.control.play.show) {
        // 有播放按钮
        if (this.option.control.play.position === 'top') {
          this.playPosition[1] = this.marginTop + BUTTON_SIZE / 2
          this.topPosition[1] = this.marginTop + BUTTON_SIZE + BUTTON_SIZE / 2
          this.bottomPosition[1] = this.marginTop + this.allHeight - BUTTON_SIZE / 2

          this.linePosition1[1] = this.marginTop + BUTTON_SIZE * 2
          this.linePosition2[1] = this.marginTop + this.allHeight - BUTTON_SIZE
        } else if (this.option.control.play.position === 'bottom') {
          this.playPosition[1] = this.marginTop + this.allHeight - BUTTON_SIZE / 2
          this.topPosition[1] = this.marginTop + BUTTON_SIZE / 2
          this.bottomPosition[1] = this.marginTop + this.allHeight - BUTTON_SIZE - BUTTON_SIZE / 2

          this.linePosition1[1] = this.marginTop + BUTTON_SIZE
          this.linePosition2[1] = this.marginTop + this.allHeight - BUTTON_SIZE * 2
        } else {
          throw new RangeError('\'opt.play.position\' must \'top\' of \'bottom\'')
        }
      } else {
        // 无播放按钮
        this.playPosition = null
        this.topPosition[1] = this.marginTop + BUTTON_SIZE / 2
        this.bottomPosition[1] = this.marginTop + this.allHeight - BUTTON_SIZE / 2

        this.linePosition1[1] = this.marginTop + BUTTON_SIZE
        this.linePosition2[1] = this.marginTop + this.allHeight - BUTTON_SIZE
      }
    } else {
      // 其他形式
    }
  }

  /**
   * 根据传入的index 获取对应的位置信息
   */
  getPointPositionByIndex(length, index) {
    let itemPoint = []
    if (this._displayStyle === 'horizontal') {
      const pointStart = this.marginLeft + BUTTON_SIZE * ((this.option.control.play.show && this.option.control.play.position === 'left') ? 2 : 1)
      const width = this.linePosition2[0] - this.linePosition1[0]

      itemPoint = [ pointStart + width / (length + 1) * (index + 1), this.style.middleHeight ]
    } else if (this._displayStyle === 'vertical') {
      const pointStart = this.marginTop + BUTTON_SIZE * ((this.option.control.play.show && this.option.control.play.position === 'top') ? 2 : 1)
      const width = this.linePosition2[1] - this.linePosition1[1]

      itemPoint = [ this.style.middleWidth, pointStart + width / (length + 1) * (index + 1) ]
    }
    return itemPoint
  }
}
